module.exports = __webpack_public_path__ + "static/media/32-bnder.a6b8a0c7.mp3";